<template>
    <div>
        <users-select
            :users="users"
            color="#009BDB"
            type="sender"
            @changed="onUserChangedHandler($event, 'Senders')"
            @changeSearch="onUserChangedHandler($event, 'Senders')"
        />
        <users-select
            :users="users"
            color="#F7A310"
            type="receiver"
            @changed="onUserChangedHandler($event, 'Receivers')"
            @changeSearch="onUserChangedHandler($event, 'Receivers')"
        />
    </div>
</template>

<script>
import UsersSelect from './UsersSelect.vue'

export default {
    name: 'UsersFilter',
    components: {
        UsersSelect,
    },
    data() {
        return {
            filter: {},
            selectedSenders: [],
            selectedReceivers: [],
            users: [],
        }
    },
    methods: {
        applyUsersFilters() {
            const senders = this.selectedSenders.length > 0 ? this.idsToArray(this.selectedSenders) : null
            const receivers = this.selectedReceivers.length > 0 ? this.idsToArray(this.selectedReceivers) : null

            this.filter = {
                senders,
                receivers,
            }

            this.$emit('changed', this.filter)
        },
        onUserChangedHandler(users, type) {
            this[`selected${type}`] = this.mapOptionsToUsers(users)
            this.applyUsersFilters()
        },
        mapOptionsToUsers(options) {
            return options.map((opt) => {
                return {
                    id: opt.value,
                    name: opt.label,
                }
            })
        },
        idsToArray(arr) {
            return arr.map((e) => e.id)
        },
    },
}
</script>

<style></style>
